import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { CarrerasPage } from '@/components/marketing/CarrerasPage';

export const Route = createFileRoute('/_public/carreras')({
  component: () => (
    <MarketingShell currentPath="/carreras">
      <CarrerasPage />
    </MarketingShell>
  ),
});
